import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { defer } from 'lodash';
import { loadSingleNews } from '../../AdminActions';
import { getViewNews } from '../../AdminReducer';
import ProgressBar from '../../../../components/progress-bar';
import NewsForm from '../../components/NewsForm';

class NewsDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.loadNews();
  }

  loadNews() {
    const { match: { params: { newsID } } } = this.props;
    this.setState({ loading: true });
    this.props.dispatch(loadSingleNews(newsID))
      .then(
        () => {
          this.setState({ loading: false });
        },
        () => {
          defer(this.context.router.history.push, '/admin/news');
        },
      );
  }

  render() {
    const { loading } = this.state;
    const { news } = this.props;
    return (
      <div>
        <Helmet title="Announcement Detail | Manage Announcements" />
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h2 className="page-sub-header">
                <Link to="/admin/news">All Announcements</Link>
                <span>&nbsp;<Fa name="angle-right" className="text-muted" />&nbsp;</span>
                <span>Edit</span>
              </h2>
            </div>
          </div>
          {loading && <ProgressBar />}
          {!loading && <NewsForm key={news._id ? news._id : 'new'} news={news} />}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    news: getViewNews(state),
  };
}

NewsDetailPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  news: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
};
NewsDetailPage.defaultProps = {
  news: null,
};

NewsDetailPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(NewsDetailPage);
